import React from 'react';
import Icon from './Icon';

const OfficeIcon = (props) => (
    <Icon {...props}>
        <path
            d="M9 6V4.5A1.5 1.5 0 0 1 10.5 3H13.5A1.5 1.5 0 0 1 15 4.5V6M5 6H19A2 2 0 0 1 21 8V18A2 2 0 0 1 19 20H5A2 2 0 0 1 3 18V8A2 2 0 0 1 5 6ZM3 10L10.3 14.2A3.5 3.5 0 0 0 13.7 14.2L21 10M12 15.5V17.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default OfficeIcon;